import React from "react"
import AboutGallery from "../../components/noone/AboutGallery"
import AboutInfo from "../../components/noone/AboutInfo"
import AboutMap from "../../components/noone/AboutMap"
import AboutStaff from "../../components/noone/AboutStaff"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/noone/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const about = () => (
  <Layout>
    <SEO title={PAGE.title.about} siteTitle="noone" />
    <HeadingL title={PAGE.title.about} target="noone" />
    <AboutInfo />
    <AboutMap />
    <AboutStaff />
    <AboutGallery />
  </Layout>
)

export default about
